export const eventSourceAwsCloudWatch = 'eaa12aa4-46e9-4f3c-98a2-2a43671a316b';
export const eventSourceAwsConfig = '137e8fe9-c3bb-4e11-8023-708893eeda57';
export const eventSourceAwsSecurityHub = '5a228e04-b7b5-4cf1-82c7-ab657ddea0ae';
export const eventSourceDisruptOpsGovernance = '7cc01081-2260-4176-86ae-092f98cb6aa0';
